var map = {
	"./development": 13877,
	"./development.js": 13877,
	"./prelive": 44931,
	"./prelive.js": 44931,
	"./production": 91549,
	"./production.js": 91549,
	"./stage": 95982,
	"./stage.js": 95982,
	"./test": 50894,
	"./test.js": 50894
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15980;